import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addTour = (FormData, setFormData, navigate) => {
  axiosInstance
    .post("/tour/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Tour added successfully") {
        toast.success("Tour added successfully");
        setFormData({
          tourName: "",
          companyId: "",
          city: "",
          division: "",
          country: "",
          startDate: "",
          endDate: "",
          minPeople: "",
          maxiPeople: "",
          price: "",
          discount: "",
          tax: "",
          cancelationPolicy: "",
          overview: "",
          includeOrexclude: "",
          description: "",
          additionalInformation: "",
          travelTips: "",
          others: "",
          isDhoorbinChoice: 0,
          isCustomerChoice: 0,
          isFeatured: 0,
          isCoupleFriendly: 0,
          isIdRequired: 0,
          status: 1,
          createdAt: new Date().toISOString(),
          images: [],
        });
        navigate("/admin/tours");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const getTourDetails = (id, setFormData, setImages) => {
  axiosInstance
    .get(`/tour/tour-details/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.data !== null) {
        const data = res.data.data;
        setFormData({
          id: data.id,
          tourName: data.tourName,
          companyId: data.companyId,
          city: data.city,
          division: data.division,
          country: data.country,
          startDate: data.startDate.split("T")[0],
          endDate: data.endDate.split("T")[0],
          minPeople: data.minPeople,
          maxiPeople: data.maxiPeople,
          price: data.price,
          discount: data.discount,
          tax: data.tax,
          cancelationPolicy: data.cancelationPolicy,
          overview: data.overview,
          includeOrexclude: data.includeOrexclude,
          description: data.description,
          additionalInformation: data.additionalInformation,
          travelTips: data.travelTips,
          others: data.others,
          isDhoorbinChoice: data.isDhoorbinChoice,
          isCustomerChoice: data.isCustomerChoice,
          isFeatured: data.isFeatured,
          isCoupleFriendly: data.isCoupleFriendly,
          isIdRequired: data.isIdRequired,
          status: data.status,
          createdAt: new Date().toISOString(),
          images: data.images,
        });
        setImages(res.data.images || []);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const updateTour = (FormData, navigate) => {
  axiosInstance
    .put("/tour/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Tour & images updated successfully") {
        toast.success("Tour updated successfully");
        navigate("/admin/tours");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
export const getTourList = (setTourData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/tour/tours?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setTourData(res.data.data);
      setPageData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const deleteTour = (setTourData, setPageData, Page, Limit, id) => {
  axiosInstance
    .delete(`/tour/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Tour deleted successfully") {
        toast.success("Tour deleted");
        getTourList(setTourData, Page, Limit, setPageData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const allTours = (setData) => {
  axiosInstance
    .get("/tour/all-tours", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const tourBookingReport = (
  setData,
  StartDate,
  EndDate,
  SelectedTour,
  SelectedCustomer,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .get(
      `/order/tour/report?tourId=${SelectedTour}&bookedBy=${SelectedCustomer}
&fromDate=${EndDate ? StartDate : ""}
&toDate=${StartDate ? EndDate : ""}`,
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      setData(res.data.data);
      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const getMetaData = (setTours, setCustomers, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get(`/order/tour/metaData`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setTours(res.data.tours);
      setCustomers(res.data.users);

      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
